import { APP_VERSION } from '../../config/appVersion';
import type { AndroidInstalledVersion } from '../../core/config/androidUpdate';
import { isAndroidNativeRuntime } from '../../adapters/mobile/apkInstaller';

/** Read installed app version (native build prefers Capacitor App.getInfo). */
export async function readInstalledAndroidVersion(): Promise<AndroidInstalledVersion> {
  if (!isAndroidNativeRuntime()) {
    return { versionName: APP_VERSION, versionCode: 0 };
  }
  try {
    const { App } = await import('@capacitor/app');
    const info = await App.getInfo();
    const versionCode = Number.parseInt(String(info.build ?? '0'), 10);
    return {
      versionName: String(info.version || APP_VERSION),
      versionCode: Number.isFinite(versionCode) ? versionCode : 0,
    };
  } catch {
    return { versionName: APP_VERSION, versionCode: 0 };
  }
}
